import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { yearValueSelected } from '../../redux/common';

export default function useYesrSelectbox() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState("");

  const onOpen = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const onClick = useCallback((item) => {
    setValue(item);
    setOpen(false);
    dispatch(yearValueSelected(item));
  }, [value])

  const onReset = useCallback(() => {
    setOpen(false);
    setValue("");
    dispatch(yearValueSelected(""));
  }, [open])

  return [open, value, onOpen, onClick, onReset];
}